import React from 'react';
import { Link } from 'react-router-dom';



const GalleryGrid = ({ articles }) => (
    <>
    <div class="gallery-container">
    {articles.map((article, key) => (
        <Link key={key} to={`/facility/${article.name}`}>
        <div className="responsive">
        <div class="gallery" key={key}>
            <img src={article.primaryPic} width="300" height="200" alt="not found"/>
            <div class="des">{article.title}</div>
            </div>
        </div>
        </Link>
    ))}
    </div>
    </>
);

export default GalleryGrid; 